import React from 'react';
import Page from '../../layout/Page';
import Awards from '../expressPass/Awards';
import WashClub from '../washClub/Management';
import WashBundles from '../codes/WashBundles';
import KioskItems from '../settings/KioskItems';
import MobileProducts from '../mobile/Products';
import FulfillableProducts from '../fulfillment/Products';
import EGift from './EGift';
import AllowedFeatures, { featureNames } from '../../navigation/AllowedFeatures';

const Index = ({ ...props }) => {

    return (
        <Page
            title='Products'
            icon='coins'
            tabs
        >
            <KioskItems tab='Kiosk Items' />
            <WashClub tab='Wash Clubs' />
            <Awards tab='ExpressPass' />
            <MobileProducts tab='Mobile' />
            <FulfillableProducts tab='Fulfillment' />
            <WashBundles tab='Bundle Codes' />
        </Page>
    );
}

export default Index;